import React, { useId } from "react";

export default function AppField({
  label,
  help,
  error,
  required = false,
  layout = "stacked",
  size = "md",
  labelWidth,
  bodyWidth,
  bodyMinWidth,
  bodyMaxWidth,
  className = "",
  style,
  children,
}) {
  const labelId = useId();
  const helpId = useId();
  const errorId = useId();
  const describedById = error ? errorId : help ? helpId : undefined;

  const enhancedChildren = React.Children.map(children, (child) => {
    if (!React.isValidElement(child) || typeof child.type === "string") {
      return child;
    }

    const nextProps = {};

    if (child.props.size === undefined) {
      nextProps.size = size;
    }

    if (label) {
      nextProps["aria-labelledby"] = child.props["aria-labelledby"]
        ? `${child.props["aria-labelledby"]} ${labelId}`
        : labelId;
    }

    if (describedById) {
      nextProps["aria-describedby"] = child.props["aria-describedby"]
        ? `${child.props["aria-describedby"]} ${describedById}`
        : describedById;
    }

    return Object.keys(nextProps).length > 0 ? React.cloneElement(child, nextProps) : child;
  });

  const classes = [
    "ds-field",
    layout === "inline" ? "ds-field--inline" : "",
    size === "sm" ? "ds-field--sm" : "",
    size === "md" ? "ds-field--md" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  const fieldStyle = {
    ...style,
    ...(labelWidth ? { "--ds-field-inline-label-width": labelWidth } : {}),
    ...(bodyWidth ? { "--ds-field-body-width": bodyWidth } : {}),
    ...(bodyMinWidth ? { "--ds-field-body-min-width": bodyMinWidth } : {}),
    ...(bodyMaxWidth ? { "--ds-field-body-max-width": bodyMaxWidth } : {}),
  };

  return (
    <div className={classes} style={fieldStyle}>
      {label ? (
        <span className="ds-field__label" id={labelId}>
          {label}
          {required ? <span className="ds-field__required">*</span> : null}
        </span>
      ) : null}
      <span className="ds-field__body">
        {enhancedChildren}
        {error ? <span className="ds-field__error" id={errorId}>{error}</span> : null}
        {!error && help ? <span className="ds-field__help" id={helpId}>{help}</span> : null}
      </span>
    </div>
  );
}
